import {LegendList} from './details-panel'

### Legend

*Geological field observations collected in multiple apps.*

<LegendList />

This prototype integration is funded by the National Science Foundation
under [RISE-2324579](https://www.nsf.gov/awardsearch/showAward.do?AwardNumber=2324579).
